module.exports = __webpack_public_path__ + "img/icon_withdrawal05.0eaa3656.png";